import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DeleteConfirmationData {
  message?: string;
  cancelButtonText?: string;
  deleteButtonText?: string;
}

@Component({
  selector: 'app-delete-confirmation-dialog',
  standalone: false,
  templateUrl: './delete-confirmation-dialog.component.html',
  styleUrl: './delete-confirmation-dialog.component.scss'
})
export class DeleteConfirmationDialogComponent {
  message: string;
  cancelButtonText: string;
  deleteButtonText: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DeleteConfirmationData
  ) {
    // Set default values or use provided data
    this.message = data?.message || 'settings.my_championed.delete_confirmation_message';
    this.cancelButtonText = data?.cancelButtonText || 'settings.my_championed.cancel_button';
    this.deleteButtonText = data?.deleteButtonText || 'settings.my_championed.delete_button';
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onDelete(): void {
    this.dialogRef.close(true);
  }
}
